import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity4 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_4;
}

export default GravelRoadTileEntity4;
